import { Component, OnInit, Injector, Input } from '@angular/core';
import { QuoteTabWizardComponent } from '../quoteTabWizard/quoteTabWizard.component';
import { monitorPeriodsService } from '../../services/monitorPeriods/monitorPeriods.service';
import { QuotePanelsTabsList } from '../../enums/QuotePanelsTabs.list';
import { getPeriodName } from '../../interfaces/historyItem';

@Component({
  selector: 'app-mobile-quoteTabWizard',
  template: require('./mobile-quoteTabWizard.component.html'),
  styles: [require('./mobile-quoteTabWizard.component.scss'), ]
})
export class MobileQuoteTabWizardComponent extends QuoteTabWizardComponent implements OnInit {

  constructor(injector: Injector, monitorPeriodsService: monitorPeriodsService) {

    super(injector , monitorPeriodsService )
    
   }

  ngOnInit() {

    if (this.activeTab != QuotePanelsTabsList.WIZARD && this.unsubscribed == false) {
      //    this.chartInstanceService.select.unsubscribe();
      this.unsubscribed = true;
      }
      
      if (this.activeTab == QuotePanelsTabsList.WIZARD && this.selectedChart != null) {
          this.InitMonitor();
          this.updateM();
      }
      if (this.activeTab == QuotePanelsTabsList.WIZARD) {
          this.unsubscribed = false;
      }

      this.selectBS = this.selectedChart.period;
      this.selectVL = this.selectedChart.period;

      setTimeout(() => {
        
          this.onChangeBS(this.selectBS);
          this.onChangeVL(this.selectVL);
          
      }, 1000);
     

  }


  public  PeriodName(v:any)
  {
    return getPeriodName(v)
  }
  //@inpute 

  @Input() public set updateSymbolInfo(v:any)
  {
    this.ngOnInit()
  }

  


}
